import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router'
import routes from '../routes';
import ReduxModal from './modal';

export default class Root extends Component {
    static propTypes = {
        store: React.PropTypes.object.isRequired,
        history: React.PropTypes.object.isRequired
    };

	render() {
		return (
			<div>
				<Provider store={this.props.store}>
          <div>
  					<Router history={this.props.history}>
  						<div>
  							{routes}
  						</div>
  					</Router>
            <ReduxModal />
          </div>
				</Provider>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./js/containers/Root.js
 **/